import { composeDetailSearchFilter } from 'utils/insightModal/composeDetailSearchFilter'
import { composeDrillDownWidgetSetting } from 'utils/insightModal/composeDrillDownWidgetSetting'
import { SearchFilterComposingStrategy } from 'utils/insightModal/strategy/searchFilterComposing/searchFilterComposingStrategy'
import { WidgetSettingComposingStrategy } from 'utils/insightModal/strategy/widgetSettingComposing/widgetSettingComposingStrategy'
import { InsightContentSettingType } from 'components/insightContent/types'
import AnalysisFilter from 'types/analysisFilter'
import { toFilter } from '../../../../../utils/widgetUtil'
import { WordCloudWidgetsType, InsightObjective } from '../../types'

export const convertToInsightContentSetting = (
  widgetSetting: WordCloudWidgetsType,
  strategy: SearchFilterComposingStrategy,
  selection?: Array<InsightObjective>
) => {
  const { viewOption } = widgetSetting

  const insightContentSetting = ({
    viewOption: viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    topicInfos: widgetSetting.topicInfos!,
    drillDownTypes: [''],
    drillDownFilter: {} as AnalysisFilter,
    selectedTopicInfo: widgetSetting.selectedTopic,
    topicId: widgetSetting.selectedTopic.topicId!
  } as unknown) as InsightContentSettingType
  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  if (selection && selection.length > 0) {
    insightContentSetting.selectionName = selection?.[0].name
    if (selection.length === 2) {
      insightContentSetting.selectionSecondName = selection?.[1].name
    }

    const insights = selection.map((item) => item.insight)
    insightContentSetting.selectionFilter = composeDetailSearchFilter(
      strategy,
      widgetSetting,
      insights
    )
  }

  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: WordCloudWidgetsType,
  strategy: WidgetSettingComposingStrategy,
  selection?: Array<InsightObjective>
) => {
  if (!widgetSetting || typeof widgetSetting !== 'object') {
    return {}
  }

  if (!selection || selection.length === 0) {
    return {}
  }

  const insights = selection.map((item) => item.insight)
  return composeDrillDownWidgetSetting(strategy, widgetSetting, insights)
}
